export * from './abteilung-delete-request.interface';
export * from './abteilung-delete-response.interface';
export * from './abteilung-delete.shapes';
